import {
  Home,
  Person,
  People,
  Inventory2,
  RequestQuote,
  AttachMoney,
  AccountBalance,
  Payments,
  CreditCard,
  Category,
  AccountBalanceWalletOutlined,
  BusinessCenter,
  ShoppingCart,
  BrandingWatermark,
  PrecisionManufacturing,
  ViewInAr,
  Straighten,
  MonetizationOn,
  ReceiptLong,
  GroupAdd,
  Engineering,
  Paid,
  Receipt, HomeOutlined,
  Iron,
  Create,
  MoneySharp,
  Sell,
  CategoryRounded,
  LocalShipping,
  SwapVert,

} from '@mui/icons-material';

import { SvgIconComponent } from '@mui/icons-material';
import * as path from '../routes/RoutesNames';

export type Menu = {
  id: number;
  screenName: string;
  screenRoute: string;
  subscreenRoute?: string;
  icon: SvgIconComponent;
  active: boolean;
  subMenu?: any[]
};
let idCount = 0
const id = () => {
  return idCount++
}
// @ts-ignore - .
export const menus: readonly Menu[] = [
  {
    id: id(),
    screenName: 'Home',
    screenRoute: path.Home,
    icon: Home,
    active: true,
  },
  {
    id: id(),
    screenName: 'Cadastros',
    screenRoute: 'Cadastros',
    icon: Create,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Banco',
        screenRoute: path.Banco,
        subscreenRoute: path.BancoCadastrar,
        icon: AccountBalance,
        active: true,
      },
      {
        id: id(),
        screenName: 'Categoria Financeira',
        screenRoute: 'CategoriaFinanceira',
        icon: Category,
        active: true,
      },
      {
        id: id(),
        screenName: 'Centro de Custo',
        screenRoute: 'CentroCusto',
        icon: BusinessCenter,
        active: true,
      },
      {
        id: id(),
        screenName: 'CFOP',
        screenRoute: path.Cfop,
        icon: Receipt,
        active: true,
      },
      {
        id: id(),
        screenName: 'Clientes',
        screenRoute: path.Cliente,
        subscreenRoute: path.ClienteAtualizar,
        icon: People,
        active: true,
      },
      {
        id: id(),
        screenName: 'Condição de Pagamento',
        screenRoute: 'CondicaoPagamento',
        icon: Payments,
        active: true,
      },
      {
        id: id(),
        screenName: 'Conta Bancária',
        screenRoute: 'ContaBancaria',
        icon: AccountBalanceWalletOutlined,
        active: true,
      },
      {
        id: id(),
        screenName: 'Fabricante',
        screenRoute: 'Fabricante',
        icon: PrecisionManufacturing,
        active: true,
      },
      {
        id: id(),
        screenName: 'Forma de Pagamento',
        screenRoute: 'FormaPagamento',
        icon: MonetizationOn,
        active: true,
      },
      {
        id: id(),
        screenName: 'Grupo de Clientes',
        screenRoute: path.GrupoCliente,
        icon: GroupAdd,
        active: true,
      },
      {
        id: id(),
        screenName: 'Grupo de Produtos',
        screenRoute: 'GrupoProduto',
        icon: ShoppingCart,
        active: true,
      },
      {
        id: id(),
        screenName: 'Tipo de Pagamento',
        screenRoute: 'TipoPagamento',
        icon: CreditCard,
        active: true,
      },
      {
        id: id(),
        screenName: 'Unidade de Medida',
        screenRoute: 'UnidadeMedida',
        icon: Straighten,
        active: true,
      },
      {
        id: id(),
        screenName: 'Usuários',
        screenRoute: path.Usuario,
        subscreenRoute: path.UsuarioAtualizar,
        icon: Person,
        active: true,
      }
    ]
  },
  {
    id: id(),
    screenName: 'Compras',
    screenRoute: 'Compras',
    icon: HomeOutlined,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Importação XML/TXT',
        screenRoute: path.ImportacaoXML,
        active: true,
      }
    ]
  },
  {
    id: id(),
    screenName: 'Financeiro',
    screenRoute: 'Financeiro',
    icon: MoneySharp,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Boletos',
        screenRoute: path.Boleto,
        icon: Engineering,
        active: true,
      },
      {
        id: id(),
        screenName: 'Contas a Pagar',
        screenRoute: path.ContasPagar,
        icon: Paid,
        active: true,
      },
      {
        id: id(),
        screenName: 'Caixa Lançamento',
        screenRoute: path.CaixaLancamento,
        icon: Paid,
        active: true
      },
      {
        id: id(),
        screenName: 'Contas a Receber',
        screenRoute: path.ContasReceber,
        icon: AttachMoney,
        active: true,
      },

      {
        id: id(),
        screenName: 'Prestação de Contas',
        screenRoute: path.PrestacaoDeContas,
        subscreenRoute: path.PrestacaoDeContasCadastro,
        icon: RequestQuote,
        active: true,
      },
      {
        id: id(),
        screenName: 'Nota Fiscal',
        screenRoute: path.NotaFiscal,
        // subscreenRoute: path.NotaFiscal,
        icon: RequestQuote,
        active: true,
      }
    ]
  },
  {
    id: id(),
    screenName: 'Logistica',
    screenRoute: 'Logistica',
    icon: LocalShipping,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Movimentação de Estoque',
        screenRoute: path.MovimentacaoEstoque,
        icon: SwapVert,
        active: true,
      },
      {
        id: id(),
        screenName: 'Reajuste de Estoque',
        screenRoute: path.ReajusteEstoque,
        icon: SwapVert,
        active: true,
      },
    ]
  },
  {
    id: id(),
    screenName: 'Produtos',
    screenRoute: 'Produtos',
    icon: CategoryRounded,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Produto',
        screenRoute: 'Produto',
        icon: Inventory2,
        active: true,
      },
    ]
  },
  {
    id: id(),
    screenName: 'Ordem Serviço',
    screenRoute: 'OrdemServico',
    icon: Sell,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Ordem de Serviço',
        screenRoute: path.OrdemServico,
        icon: Engineering,
        active: true,
      },
      {
        id: id(),
        screenName: 'Maquina',
        screenRoute: path.Maquina,
        icon: Iron,
        active: true,
      },
      {
        id: id(),
        screenName: 'Marca',
        screenRoute: 'Marca',
        icon: BrandingWatermark,
        active: true,
      },
      {
        id: id(),
        screenName: 'Modelo',
        screenRoute: 'Modelo',
        icon: ViewInAr,
        active: true,
      }
    ]
  },
  {
    id: id(),
    screenName: 'Vendas',
    screenRoute: 'Vendas',
    icon: AttachMoney,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Pedido de Venda',
        screenRoute: path.Pedido,
        icon: ReceiptLong,
        active: true,
      },

    ]
  }
  // {
  //   id: id(),
  //   screenName: 'Logout',
  //   screenRoute: 'Logout',
  //   icon: Logout,
  //   active: true,
  // }
] as const;
